export const InaccessibleComponentI18nKeys = {
  alternative: {
    firstStep: 'accessibility-wizard.rules-list.inaccessible-components.element.content.first-step',
    secondStep: 'accessibility-wizard.rules-list.inaccessible-components.element.content.alternative.second-step'
  },
  followArticle: {
    firstStep: 'accessibility-wizard.rules-list.inaccessible-components.element.content.follow-article.first-step'
  },
  noAlternative: {
    firstStep: 'accessibility-wizard.rules-list.inaccessible-components.element.no-alternative.first-step'
  },
  passedSubtitle: 'accessibility-wizard.rules-list.inaccessible-components.element.content.passed.subtitle',
  reinstall: {
    firstStep: 'accessibility-wizard.rules-list.inaccessible-components.element.content.first-step',
    secondStep: 'accessibility-wizard.rules-list.inaccessible-components.element.content.reinstall.second-step'
  },
  rescanStep: 'accessibility-wizard.rules-list.inaccessible-components.element.rescan-step',
  subtitle: 'accessibility-wizard.rules-list.inaccessible-components.element.content.subtitle'
};
//# sourceMappingURL=translation-keys.js.map